import { Injectable } from "@angular/core";

import { RestReadServiceBase } from "@definitiv-packages/angular-dba-library";

import { SafetyPointFormModelView } from "../../types/SafetyPointFormModel";

@Injectable({
    providedIn: 'root'
})
export class SafetyPointFormModelViewService extends RestReadServiceBase<SafetyPointFormModelView> {
    constructor() { super("SafetyPointFormModelView"); }
}